import { Reveal } from "@/components/Reveal";

export const SectionHeading = ({ eyebrow, title, subtitle, align = "center", light = false, className = "" }) => (
  <Reveal className={`${align === "center" ? "mx-auto text-center" : "text-left"} max-w-3xl ${className}`}>
    {eyebrow && (
      <span className={`eyebrow ${light ? "text-sky" : "text-ocean"}`} data-testid="section-eyebrow">{eyebrow}</span>
    )}
    <h2 className={`mt-4 font-serif text-3xl font-bold leading-tight text-balance sm:text-4xl lg:text-5xl ${light ? "text-white" : "text-navy"}`}>
      {title}
    </h2>
    {subtitle && (
      <p className={`mt-5 text-base leading-relaxed ${light ? "text-white/70" : "text-slate-600"}`}>{subtitle}</p>
    )}
  </Reveal>
);
